import React from 'react'
import styles from './SelectInput.module.scss'

export interface SelectOption {
  value: string | number
  label: string
}

interface SelectInputProps {
  id?: string
  name?: string
  value: string | number
  onChange: (value: string) => void
  options: SelectOption[]
  placeholder?: string
  disabled?: boolean
  error?: boolean
  className?: never
}

export const SelectInput: React.FC<SelectInputProps> = ({
  id, name, value, onChange, options, placeholder,
  disabled = false, error = false,
}) => (
  <select
    id={id}
    name={name}
    value={value}
    onChange={(e) => onChange(e.target.value)}
    disabled={disabled}
    className={[styles.select, error ? styles.error : ''].filter(Boolean).join(' ')}
  >
    {placeholder && <option value="">{placeholder}</option>}
    {options.map((opt) => (
      <option key={opt.value} value={opt.value}>{opt.label}</option>
    ))}
  </select>
)
